<template>
  <v-container fluid>
    <!-- 輸入框和新增按鈕 -->
    <v-layout class="align-center">
      <v-text-field
        v-model="newTag"
        label="新增標籤"
        @keyup.enter="addTodo"
      ></v-text-field>
      <v-btn color="blue lighten-2" class="ml-3" @click="addTodo">新增</v-btn>
    </v-layout>
    <!-- 待辦事項列表 -->
    <v-data-table
      :headers="headers"
      :items="tags"
      items-per-page="1000"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <v-text-field
              v-if="editTag === item"
              v-model="editTag.name"
              @keyup.enter="saveTodo"
            ></v-text-field>
            <span v-else>{{ item.name }}</span>
          </td>
          <td style="text-align: right;">
            <!-- 編輯模式 -->
            <template v-if="editTag === item">
              <v-btn color="green lighten-2" @click="saveTodo"
                >儲存</v-btn
              >
              <v-btn @click="cancelEdit" class="ml-3">取消</v-btn>
            </template>
            <template v-else>
              <v-btn color="green lighten-2" @click="editTodo(item)"
                >編輯</v-btn
              >
              <v-btn color="red lighten-2" class="ml-3" @click="deleteTodo(item.tagId)"
                >刪除</v-btn
              >
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";
export default {
  name: "label",
  mixins: [common],
  data() {
    return {
      newTag:'',
      editTag: [],
      tags: [],
      headers: [
        { text: "標籤名稱", value: "text" },
        { text: "操作", value: "action", sortable: false, align: "right" },
      ],
    };
  },
  methods: {
    ...mapActions(["getTagList", "saveTagInfo", "deleteTagInfo"]),
    // 載入資料
    async loadData() {
      try {
        this.loading = true;
        const res = await this.getTagList();
        if (res.data.statusCode === 0) {
          // console.log(`getTagList ${JSON.stringify(res.data.data)}`);
          this.tags = res.data.data;
          console.log(`getTagList ${JSON.stringify(this.tags)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getTagList error`, e.stack);
      }
    },
    // 新增
    async addTodo() {
      if (this.newTag.trim() === "") return;
      try {
        this.loading = true;
        console.log(`newTag ${JSON.stringify(this.newTag)}`);
        const res = await this.saveTagInfo({
          name: this.newTag,
        });
        if (res.data.statusCode === 0) {
          console.log(`saveTagInfo ${JSON.stringify(res.data.data)}`);
          this.newTag = "";
          this.loadData();
        }
      } catch (e) {
        this.loading = false;
        console.log(`saveTagInfo error`, e.stack);
      }
    },
    // 進入編輯模式
    editTodo(item) {
      console.log("編輯待辦事項:", item);
      this.editTag = item;
    },
    // 編輯模式 儲存
    async saveTodo() {
      try {
        if (this.editTag.name.trim() === "") return;
        this.loading = true;
        console.log(`editTag ${JSON.stringify(this.editTag)}`);
        const res = await this.saveTagInfo({
          name: this.editTag.name,
          tagId: this.editTag.tagId,
        });
        if (res.data.statusCode === 0) {
          console.log(`saveTagInfo ${JSON.stringify(res.data.data)}`);
          this.editTag = "";
          this.loadData();
        }
      } catch (e) {
        this.loading = false;
        console.log(`saveTagInfo error`, e.stack);
      }
    },
    // 退出編輯模式
    cancelEdit() {
      this.editTag = [];
      this.loadData();
    },
    async deleteTodo(item) {
      // console.log('刪除待辦事項:', item);
      this.showAlert({
        title: "提示",
        content: "是否確定要刪除此標籤？",
        confirmEvent: async () => {
          this.hideAlert();
          await this.deleteTagInfo({ tagId: item });
          this.loadData();
        },
      });
    },
  },
  //  頁面載入時加載資料
  created() {
    this.loadData();
  },
};
</script>

<style scoped>

</style>